// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-invite-restricted-area{height:100%;display:flex;flex-direction:column}.ac-invite-restricted-area__sticky-banner{position:fixed;top:56px;width:calc(100% - 126px);overflow:hidden}.ac-invite-restricted-area__empty-state{display:flex;flex-direction:column;align-items:center}.ac-invite-restricted-area>div{flex-direction:column;flex-grow:1;display:flex}.ac-invite-restricted-area__wrapper{height:100%;display:flex;flex-direction:column}\n", ""]);
// Exports
module.exports = exports;
